import axios from "axios";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";

const GetInitiativeFundList = async (IdeaId) => {
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;
  const accessToken = sessionStorage.getItem("access_token");
  try {
    const response = await AxiosInstance1.get(
      `/api/InitiativeDetail/GetInitiativeFundList`,
      {
        params: { IdeaId }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching initiative fund list:", error);
    throw new Error("Failed to fetch initiative fund list");
  }
};

export default GetInitiativeFundList;
